import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenesysWrapupPanelComponent } from './genesys-wrapup-panel.component';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    GenesysWrapupPanelComponent
  ],
  exports: [
    GenesysWrapupPanelComponent
  ],
  imports: [
    BrowserModule,
    TranslateModule.forChild(),
    CommonModule,
    SvgIconModule,
    MatMenuModule
  ]
})
export class GenesysWrapupPanelModule { }
